import { Select, SelectOption, SelectVariant } from '@patternfly/react-core'
import * as React from 'react'
import { useCallback, useState } from 'react'

type Props = {
  onChange: (selected: string[]) => void
  placeHolderValue?: string
  values: string[]
}

export const MultipleSelectComponent = function ({
  onChange,
  placeHolderValue,
  values,
}: Props) {
  const [selected, setSelected] = useState<string[]>([])
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const children = () => {
    return values.map((value, index) => {
      return <SelectOption key={index} value={value} />
    })
  }

  const onSelect = useCallback(
    (event, selection, isPlaceholder) => {
      if (isPlaceholder) {
        setSelected([])
        onChange([])
      } else {
        let updatedSelected = selected
        if (selected.includes(selection)) {
          updatedSelected = selected.filter((item) => item !== selection)
        } else {
          updatedSelected = selected.concat(selection)
        }

        setSelected(updatedSelected)
        onChange(updatedSelected)
      }
    },
    [onChange, selected],
  )

  const onToggle = useCallback(() => {
    setIsOpen(!isOpen)
  }, [isOpen])

  return (
    <Select
      variant={SelectVariant.checkbox}
      aria-label="Select Type"
      onToggle={onToggle}
      onSelect={onSelect}
      selections={selected}
      isOpen={isOpen}
      placeholderText={placeHolderValue}
    >
      {children()}
    </Select>
  )
}

export default MultipleSelectComponent
